<template>
    <Modal :close_button="true" :size="'modal-lg'" mid="create-ticket">
        <template v-slot:header>
            <span>{{$t('management_console.helpdesk.create')}}</span>
        </template>
        <template v-slot:body>
            <div class="row mb-3">
                <div class="col">
                    <label class="form-label fw-bold">{{$t('management_console.common.subject')}}</label>
                    <input v-model="form.subject" type="text" class="form-control" :placeholder="$t('management_console.helpdesk.subject_placeholder')" :aria-label="$t('management_console.common.subject')">
                    <small class="d-block mt-1 mb-2">{{$t('management_console.helpdesk.subject_help')}}</small>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col">
                    <label class="form-label fw-bold">{{$t('management_console.common.description')}}</label>
                    <textarea v-model="form.description" rows="10" class="form-control" :aria-label="$t('management_console.common.description')"></textarea>
                    <small class="d-block mt-1 mb-2">{{$t('management_console.helpdesk.description_help')}}</small>
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <button :disabled="!valid_form && !loading" type="button" class="btn btn-primary pl-3 pr-3 ml-3 mr-3" @click="submit()">
                <span class="small">{{$t('controls.create')}}</span>
            </button>
            <button type="button" class="btn btn-secondary pl-3 pr-3 ml-3 mr-3" @click="cancel()">
                <span class="small">{{$t('controls.cancel')}}</span>
            </button>
        </template>
    </Modal>
</template>

<script>
import TicketStore from '@/common/store/ticket.js'
// import BootstrapIcon from '@/common/directive/BootstrapIcon'

export default {
    components: {
        // BootstrapIcon
    },
    data: function () {
        return {
            loading: false,
            form: {
                subject: '',
                description: '',
                file: {}
            }
        }
    },
    computed: {
        valid_form: function () {
            return this.form.subject.length > 3 && this.form.description.length > 30
        }
    },
    methods: {
        cancel: async function () {
            this.$bus.$emit('Modal/hide/create-ticket')
        },
        submit: async function () {
            this.loading = true

            const payload = {
                subject: this.form.subject,
                description: this.form.description
            }

            const response = await TicketStore.dispatch('CREATE', payload)

            if (response.status === 0) {
                this.$bus.$emit('Modal/hide/create-ticket')
                this.form.subject = ''
                this.form.description = ''
                this.$bus.$emit('Notification/show', { title: this.$t('notifications.operation_success'), msg: this.$t('management_console.helpdesk.created'), level: 'success' })
                this.$router.push('/console/helpdesk/' + response.id)
            } else {
                this.$bus.$emit('Notification/show', { title: this.$t('notifications.something_went_wrong'), msg: this.$t('notifications.please_retry_the_operation_or_refresh'), level: 'danger' })
            }

            this.loading = false
        }
    }
}
</script>
